import { Box, Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';

import { ListPlans } from './ListPlans';
import { PlanDetailsProps, PlanFormDialog } from './PlanForm';

import LoadingScreen from '../../../components/LoadingScreen/LoadingScreen';
import { config } from './config';
import { handleError } from '../../../utils/config';
import { useHistory } from 'react-router';

export enum PlanDurations {
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}

const ManagePlan = () => {
    const [plans, setPlans] = useState<PlanDetailsProps[]>([]);
    const [loading, setLoading] = useState(true);
    const [openForm, setOpenForm] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState<PlanDetailsProps | null>(null);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const history = useHistory();

    const actions = [
        {
            label: 'Edit',
            onClick: (e: any, data: any) => {
                setSelectedPlan(data.plan);
                setOpenForm(true);
            }
        },
        {
            label: 'Delete',
            color: 'error',
            onClick: (e: any, data: any) => {
                setSelectedPlan(data.plan);
                setDeleteConfirmationModal(true);
            }
        }
    ];

    useEffect(() => {
        getAllPlans();
    }, []);


    const getAllPlans = async () => {
        setLoading(true);
        try {
            const result = await config.getAllPlans();
            setPlans(result);
        } catch (e: any) {
            if (e && e.error && e.error.message) {
                handleError(e, history);
            }
        }
        setLoading(false);
    };

    const addPlan = async (data: any) => {
        setLoading(true);
        try {
            await config.addPlan(data);
            setOpenForm(false);

        } catch (e: any) {
            if (e && e.error && e.error.message) {
                handleError(e, history);
            }
        }
        setLoading(false);
    };

    const editPlan = async (data: any) => {
        try {
            await config.editPlan(data);

        } catch (e: any) {
            if (e && e.error && e.error.message) {
                handleError(e, history);
            }
        }
    };

    const deletePlan = async () => {
        setLoading(true);
        if (!selectedPlan) return;
        try {
            await config.deletePlan({ planId: selectedPlan.id });
            setDeleteConfirmationModal(false);
            setSelectedPlan(null);
            await getAllPlans();

        } catch (e: any) {
            if (e && e.error && e.error.message) {
                handleError(e, history);
            }
        }
        setLoading(false);
    };
    const deleteFeature = async (payload: any) => {
        try {
            await config.deleteFeature(payload);
            await getAllPlans();
        } catch (e: any) {
            if (e && e.error && e.error.message) {
                handleError(e, history);
            }
        }
    };

    const handleCloseModal = () => {
        setOpenForm(false);
        setSelectedPlan(null);
    };

    const handleSubmit = async (data: any) => {
        try {
            if (selectedPlan)
                await editPlan({ ...data, id: selectedPlan?.id });
            else
                await addPlan(data);

            await getAllPlans();
            handleCloseModal();
        } catch (e: any) {
            if (e && e.error && e.error.message) {
                handleError(e, history);
            }
        }
    };

    if (loading) return <LoadingScreen />;

    return (
        <Box width="100%">
            <Box display="flex" justifyContent="space-between" pb="10px" borderBottom="2px solid gray" mb="15px">
                <Typography variant="h3">Plans</Typography>
                <Button
                    variant="contained"
                    sx={{ textTransform: 'capitalize', fontSize: '12px' }}
                    onClick={() => setOpenForm(true)}
                >
                    + Add Plan
                </Button>
            </Box>

            <ListPlans plans={plans} actions={actions} />

            {/* Add / Edit Plan Form */}
            <PlanFormDialog
                open={openForm}
                onClose={handleCloseModal}
                onSubmit={handleSubmit}
                initialData={selectedPlan && !deleteConfirmationModal ? { ...selectedPlan } : undefined}
                deleteFeature={deleteFeature}
            />

            {/* Delete Confirmation Modal */}
            <Dialog
                open={deleteConfirmationModal}
                onClose={() => setDeleteConfirmationModal(false)}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete the plan <strong>{selectedPlan?.name}</strong>?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmationModal(false)} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={deletePlan} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ManagePlan;
